<div class="level-profile">
  <!-- Level cover -->
  <app-sblock-portada
    [loading]="levelLoading"
    [backgroundColor]="coverBackgroundColor"
    [title]="coverTitle"
    [subtitle]="coverSubtitle"
    [description]="coverDescription"
    [mainImage]="coverImage"
    [links]="coverLinks"
    [primaryButtonLabel]="enrollLabel"
    [primaryButtonLink]="enrollLink"
    (secondaryAction)="goToProposal()"
  ></app-sblock-portada>

  <!-- Full gallery -->
  <app-sblock-gallery
    *ngIf="levelLoading || galleryPhotos.length"
    [loading]="levelLoading"
    [title]="galleryTitle"
    [subtitleText]="gallerySubtitle"
    [photos]="galleryPhotos"
  ></app-sblock-gallery>

  <!-- Tiny gallery -->

  <!-- Level tabs -->
  <div #proposalSection class="level-profile__tabs py-5">
    <div class="container">
      <div class="col-lg-8 offset-lg-2 px-0">
        <div class="optionsList mb-5">
          <div
            class="option"
            (click)="setActiveOption('proposal')"
            [class.activeOption]="activeOption == 'proposal'"
          >
            {{ "Propuesta Educativa" | translate }}
          </div>
          <div
            class="option"
            (click)="setActiveOption('workshops')"
            [class.activeOption]="activeOption == 'workshops'"
          >
            {{ workshopsTitle }}
          </div>
          <div
            *ngIf="regulationsHtml"
            class="option"
            (click)="setActiveOption('regulations')"
            [class.activeOption]="activeOption == 'regulations'"
          >
            {{ "Reglamento" | translate }}
          </div>
          <div class="slide" [ngStyle]="getSlideStyles()"></div>
        </div>
      </div>

      <div [ngSwitch]="activeOption">
        <div class="fadeIn" *ngSwitchCase="'proposal'">
          <h3 class="mb-3 level-profile__proposal-title">Propuesta Educativa</h3>

          <div *ngIf="proposalHtml" class="rich-text" [innerHTML]="proposalHtml | safeHtml"></div>

          <ng-container *ngIf="!proposalHtml">
            <p>
              Nuestra propuesta educativa integra la formacion academica, humana y espiritual,
              acompanando a cada estudiante en su desarrollo integral a lo largo de este nivel.
            </p>
            <p>
              Trabajamos con una metodologia activa y personalizada que promueve el pensamiento
              critico, la creatividad y los valores que caracterizan a las Adoratrices.
            </p>
          </ng-container>

          <app-sblock-gallery
            *ngIf="galleryPhotos.length"
            [photos]="galleryPhotos"
            [isTinyGallery]="true"
            [showActions]="false"
          ></app-sblock-gallery>

          <div class="workshops__enroll">
            <ng-container *ngTemplateOutlet="enrollButton"></ng-container>
          </div>
        </div>

        <div class="fadeIn" *ngSwitchCase="'workshops'">
          <div class="row workshops">
            <!-- Sidebar -->
            <aside class="col-lg-4 workshops__sidebar">
              <h5 class="workshops__sidebar-title">
                <ng-container *ngIf="hasCustomWorkshopsTitle; else defaultWorkshopsTitle">{{ workshopsTitle }}</ng-container>
                <ng-template #defaultWorkshopsTitle>Talleres extra curriculares <span>(opcionales)</span></ng-template>
              </h5>

              <!-- Mobile: dropdown to pick a single workshop to display -->
              <div
                class="workshops__select-wrap"
                *ngIf="!workshopsLoading && workshops.length"
              >
                <span class="workshops__select-label">Seleccioná un taller</span>
                <div class="workshops__select-field">
                  <i class="fas fa-graduation-cap workshops__select-icon"></i>
                  <select class="workshops__select" (change)="onWorkshopSelect($event)">
                    <option
                      *ngFor="let workshop of workshops"
                      [value]="workshop.id"
                      [selected]="workshop.id === activeWorkshop?.id"
                    >
                      {{ workshop.name }}
                    </option>
                  </select>
                </div>
              </div>

              <ul class="workshops__list">
                <!-- Skeleton rows -->
                <ng-container *ngIf="workshopsLoading">
                  <li *ngFor="let s of workshopSkeletons" class="workshops__item">
                    <span class="skeleton skeleton--text" style="width: 70%; margin: 0"></span>
                  </li>
                </ng-container>

                <ng-container *ngIf="!workshopsLoading">
                  <li
                    *ngFor="let workshop of workshops"
                    class="workshops__item"
                    [class.workshops__item--active]="workshop.id === activeWorkshop?.id"
                    (click)="setActiveWorkshop(workshop)"
                  >
                    <span>{{ workshop.name }}</span>
                    <i class="fas fa-arrow-right"></i>
                  </li>
                  <li *ngIf="!workshops.length" class="workshops__empty">
                    No hay {{ workshopsTitle.toLowerCase() }} disponibles para este nivel.
                  </li>
                </ng-container>
              </ul>

              <ng-container *ngIf="workshopsSchedule">
                <h6 class="workshops__schedules-title">Horarios:</h6>
                <ul class="workshops__schedules">
                  <li class="workshops__schedule">
                    <i class="far fa-clock"></i>
                    <span [innerHTML]="workshopsSchedule | safeHtml"></span>
                  </li>
                </ul>
              </ng-container>

              <div *ngIf="contactPhone || contactEmail" class="workshops__contact">
                <span class="workshops__contact-label">CONTACTO</span>
                <a
                  *ngIf="contactPhone"
                  class="workshops__contact-row"
                  [href]="'tel:' + contactPhone"
                >
                  <span class="workshops__contact-icon">
                    <i class="fas fa-phone-alt"></i>
                  </span>
                  <span class="workshops__contact-phone">{{ contactPhone }}</span>
                </a>
                <a
                  *ngIf="contactEmail"
                  class="workshops__contact-row"
                  [href]="'mailto:' + contactEmail"
                >
                  <span class="workshops__contact-icon">
                    <i class="fas fa-envelope"></i>
                  </span>
                  <span class="workshops__contact-email">{{ contactEmail }}</span>
                </a>
              </div>
            </aside>

            <!-- Detail skeleton -->
            <section class="col-lg-8 workshops__detail" *ngIf="workshopsLoading">
              <div class="skeleton skeleton--title"></div>
              <div class="skeleton skeleton--text skeleton--line-40"></div>
              <div class="skeleton skeleton--text"></div>
              <div class="skeleton skeleton--text skeleton--line-80"></div>
              <div class="skeleton skeleton--text skeleton--line-60"></div>
              <div class="skeleton skeleton--image" style="height: 200px; margin-top: 1.5rem"></div>
            </section>

            <!-- Detail -->
            <section class="col-lg-8 workshops__detail" *ngIf="!workshopsLoading && activeWorkshop">
              <img
                *ngIf="activeWorkshop.images.length"
                class="workshops__detail-image"
                [src]="activeWorkshop.images[0]"
                [alt]="activeWorkshop.name"
                onError="this.src='assets/images/placeholder.svg'"
                loading="lazy"
                decoding="async"
              />
              <h3 class="workshops__detail-title">{{ activeWorkshop.name }}:</h3>

              <div class="workshops__detail-meta">
                <span
                  *ngIf="activeWorkshop.levelName"
                  class="workshops__detail-meta-item workshops__detail-meta-item--level"
                >
                  <i class="fas fa-signal"></i>
                  Nivel {{ activeWorkshop.levelName }}
                </span>
                <span
                  *ngIf="activeWorkshop.daysHours"
                  class="workshops__detail-meta-item workshops__detail-meta-item--schedule"
                >
                  <i class="far fa-clock"></i>
                  {{ activeWorkshop.daysHours }}
                </span>
              </div>

              <p
                *ngFor="let paragraph of activeWorkshop.paragraphs"
                class="workshops__detail-text"
              >
                {{ paragraph }}
              </p>

              <app-sblock-gallery
                *ngIf="activeWorkshop.images.length"
                [photos]="activeWorkshopPhotos"
                [isTinyGallery]="true"
                [showActions]="false"
              ></app-sblock-gallery>

              <div class="workshops__enroll" *ngIf="activeWorkshop.enableRegistration">
                <ng-container *ngTemplateOutlet="enrollButton"></ng-container>
              </div>
            </section>
          </div>
        </div>

        <div class="fadeIn" *ngSwitchCase="'regulations'">
          <h3 class="mb-3 level-profile__proposal-title">Reglamento</h3>
          <div *ngIf="regulationsHtml" class="rich-text" [innerHTML]="regulationsHtml | safeHtml"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Boton de inscripcion del nivel: link configurable, externo por href (CUA-133) -->
<ng-template #enrollButton>
  <a
    *ngIf="enrollPath; else externalEnrollButton"
    [routerLink]="enrollPath"
    [queryParams]="enrollQueryParams"
    class="btn workshops__enroll-btn"
  >Inscripciones</a>
  <ng-template #externalEnrollButton>
    <a [href]="enrollLink" class="btn workshops__enroll-btn">Inscripciones</a>
  </ng-template>
</ng-template>
